import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'gl0006',
    ecrans: ['00-2'],
    params: [
        'cptcleint',
        'annfin',
        'perdeb',
        'perfin',
        'tymcleint',
        'vaesysnatctb',
        '?t_imp',
        '?prucleint',
        '?prscleint',
        '?cifcleint',
        '?unacleint',
        '?el1cleint',
        '?el2cleint',
        '?el3cleint',
        '?unmcleint',
        '?soncleint'
    ]
});

